export const NAV = [
  { id: "cabinet", label: "Le cabinet" },
  { id: "domaines", label: "Domaines" },
  { id: "indemnisation", label: "Indemnisation" },
  { id: "honoraires", label: "Honoraires" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Contact" },
];

export const CABINET = {
  firm: "RC AVOCATS",
  name: "Maître Pauline RÈGE CHANAL",
  address: ["Espace Forbin", "13 Place John Rewald", "13100 Aix-en-Provence"],
  phone: "04 42 38 25 84",
  phoneHref: "tel:+33442382584",
  mobile: "06 23 51 04 16",
  mobileHref: "tel:+33623510416",
  email: "pauline.rege@avocat.fr",
  siret: "818 106 643",
  serment: "2016",
  rdvUrl: "https://consultation.avocat.fr/avocat-aix-en-provence/pauline-rege-46582.html",
  hours: [
    ["Lundi – Vendredi", "9h00 – 12h30 · 14h00 – 18h30"],
    ["Rendez-vous", "Au cabinet, par téléphone ou en visioconférence"],
  ],
};

export const PHOTOS = {
  hero: {
    src: "/img/palais-hero.jpg",
    title: "Palais de justice d'Aix-en-Provence",
    author: "Lsmpascal",
    license: "CC BY-SA 3.0",
    licenseUrl: "https://creativecommons.org/licenses/by-sa/3.0/deed.fr",
    source: "https://commons.wikimedia.org/wiki/File:Palais_de_justice_Aix-en-Provence.jpg",
  },
  portrait: "/img/portrait-pauline-rege-chanal.jpg?v=2",
};

export const MARQUEE = [
  "Accidents de la circulation",
  "Dommage corporel",
  "Accidents médicaux",
  "Accidents de la vie",
  "Victimes d'infractions",
  "Réparation intégrale",
];

export const PARCOURS = [
  "Après un parcours universitaire en droit des affaires où elle fut notamment major de sa promotion à la faculté d'Aix-en-Provence, Maître Pauline Rège Chanal a débuté sa carrière d'Avocate au sein d'un cabinet d'affaires, en contentieux des entreprises, pendant plusieurs années.",
  "En rejoignant ensuite un cabinet intervenant dans le domaine de la réparation du dommage corporel du côté des compagnies d'assurances, Maître Pauline Rège Chanal a découvert une matière passionnante, technique, exigeante, mais surtout profondément humaine.",
  "Maître Pauline Rège Chanal a alors souhaité l'approfondir en suivant notamment les enseignements de l'Institut Médico-Légal de la Faculté de Médecine de Marseille, aux côtés de professionnels de santé destinés à l'expertise médico-légale, où elle a obtenu un diplôme en réparation juridique du dommage corporel.",
  "Son expérience auprès des compagnies d'assurance lui a par ailleurs permis d'en connaître les rouages internes et c'est aujourd'hui un atout précieux au service des victimes, pour évaluer justement chaque préjudice et défendre au mieux leurs intérêts.",
  "Maître Pauline Rège Chanal intervient pour ses clients sur tout le territoire français.",
];

export const PILLARS = [
  { t: "Écoute", d: "Chaque dossier commence par le temps de comprendre votre histoire, vos difficultés quotidiennes et vos attentes. Vous êtes reçu(e) par votre avocate, du premier rendez-vous à la clôture du dossier." },
  { t: "Exigence", d: "Chaque poste de préjudice est examiné avec rigueur, pièces médicales et justificatifs à l'appui, afin que rien de ce que vous avez subi ne soit oublié." },
  { t: "Disponibilité", d: "Une indemnisation peut prendre du temps. Vous êtes informé(e) à chaque étape, et vos questions reçoivent une réponse claire, dans un langage accessible." },
];

export const DOMAINES = [
  {
    k: "circulation",
    t: "Accidents de la circulation",
    d: "Conducteur, passager, piéton ou cycliste : la loi Badinter du 5 juillet 1985 organise l'indemnisation des victimes d'accidents impliquant un véhicule terrestre à moteur. Le cabinet RC AVOCATS vous accompagne face à l'assureur, dès les premières semaines, pour que l'offre qui vous est faite reflète la réalité de vos préjudices.",
    tags: ["Loi Badinter", "Offre de l'assureur", "FGAO"],
  },
  { k: "corporel", t: "Dommage corporel", d: "Blessures, séquelles, retentissement professionnel et familial : le préjudice corporel est évalué poste par poste pour tendre vers une réparation intégrale." },
  { k: "medical", t: "Accidents médicaux", d: "Erreur médicale, infection nosocomiale, aléa thérapeutique : procédure amiable devant la CCI, recours contre l'établissement ou l'ONIAM." },
  { k: "vie", t: "Accidents de la vie", d: "Chute, accident domestique, de sport ou de loisirs : votre contrat GAV ou la responsabilité d'un tiers peut ouvrir droit à indemnisation." },
  { k: "infractions", t: "Victimes d'infractions & CIVI", d: "Agression, violences : constitution de partie civile et saisine de la Commission d'indemnisation des victimes d'infractions." },
];

export const FAQ = [
  {
    q: "De combien de temps est-ce que je dispose pour agir ?",
    a: "Pour obtenir la réparation d'un dommage corporel, le délai est en principe de 10 ans à compter de la consolidation de votre état de santé, y compris pour les accidents médicaux. Devant la CIVI, la demande doit en principe être présentée dans les 3 ans de l'infraction, ce délai pouvant être prolongé lorsqu'une procédure pénale est en cours. Ces délais connaissent des exceptions : mieux vaut consulter tôt, tant que les preuves et les témoignages sont disponibles.",
  },
  {
    q: "Qu'est-ce que la consolidation ?",
    a: "C'est le moment où vos lésions se stabilisent : les soins ne visent plus à améliorer votre état mais à l'entretenir. Elle est fixée par le médecin expert et marque la frontière entre les préjudices temporaires et les préjudices permanents. Avant la consolidation, il est possible de solliciter des provisions à valoir sur l'indemnisation.",
  },
  {
    q: "Comment se déroule l'expertise médicale ?",
    a: "L'expertise peut être amiable (médecin mandaté par l'assureur) ou judiciaire (expert désigné par le juge). Le médecin vous interroge sur l'accident, vos soins et vos difficultés quotidiennes, puis vous examine. Vous avez le droit d'y être assisté(e) par un médecin-conseil de victimes et par votre avocate. Pensez à apporter l'ensemble de votre dossier médical : c'est sur ce rapport que reposera l'évaluation de vos préjudices.",
  },
  {
    q: "Accident de la route : dans quel délai l'assureur doit-il me faire une offre ?",
    a: "La loi Badinter impose à l'assureur de présenter une offre d'indemnisation au plus tard dans les 8 mois suivant l'accident. Elle peut être provisionnelle si votre état n'est pas encore consolidé ; l'offre définitive doit alors intervenir dans les 5 mois suivant la date à laquelle l'assureur a eu connaissance de la consolidation. Le non-respect de ces délais est sanctionné.",
  },
  {
    q: "Dois-je accepter l'offre de l'assureur ?",
    a: "Vous n'y êtes jamais obligé(e). Une fois la transaction signée, il devient très difficile de la remettre en cause : la loi prévoit seulement un délai de 15 jours pour la dénoncer après un accident de la circulation. Avant de signer, il est préférable de faire examiner l'offre poste par poste afin de vérifier qu'aucun préjudice n'a été oublié ou sous-évalué.",
  },
  {
    q: "Mon assureur peut-il m'imposer son avocat ?",
    a: "Non. Vous êtes libre de choisir votre avocat, y compris lorsque les frais sont pris en charge par votre contrat de protection juridique. Le médecin mandaté par l'assureur de la partie adverse défend quant à lui les intérêts de cette compagnie : d'où l'importance d'être accompagné(e) de vos propres conseils.",
  },
  {
    q: "Quels documents dois-je conserver ?",
    a: "Tout ce qui retrace l'accident et ses conséquences : constat ou procès-verbal, certificat médical initial, comptes rendus d'hospitalisation et d'examens, arrêts de travail, ordonnances, factures et frais restés à votre charge, justificatifs de revenus avant et après l'accident, attestations des proches qui vous aident au quotidien.",
  },
];

export const ETAPES = [
  {
    t: "L'expertise médicale",
    d: "Moment décisif du dossier, l'expertise fixe la nature et l'étendue de vos séquelles. Vous y êtes préparé(e) et assisté(e), idéalement aux côtés d'un médecin-conseil de victimes, afin que vos doléances soient entendues et consignées.",
    notes: ["Préparation du dossier médical", "Assistance le jour de l'expertise", "Analyse du rapport"],
  },
  {
    t: "L'évaluation des préjudices",
    d: "Sur la base de la nomenclature Dintilhac, référence utilisée par les juridictions et les assureurs, chaque poste de préjudice est identifié et chiffré : rien ne doit être laissé de côté.",
    notes: ["Déficit fonctionnel", "Souffrances endurées", "Pertes de gains", "Assistance par tierce personne", "Préjudice esthétique, d'agrément…"],
  },
  {
    t: "La négociation avec l'assureur",
    d: "L'offre d'indemnisation est examinée point par point. Lorsqu'elle est insuffisante, une contre-proposition argumentée est présentée pour rechercher un accord amiable conforme à vos droits.",
    notes: ["Analyse de l'offre", "Contre-proposition chiffrée", "Transaction"],
  },
  {
    t: "La procédure, si nécessaire",
    d: "À défaut d'accord satisfaisant, le tribunal peut être saisi : expertise judiciaire, provision, puis jugement sur la liquidation de vos préjudices. La décision d'engager une procédure est toujours prise avec vous.",
    notes: ["Référé expertise & provision", "Action au fond", "CIVI, CCI, ONIAM"],
  },
];
